export default{
	ROUTER_BASE:'/student/',
	LSKEY: 'student_user',
	CU_KEY:'student_chat_upload',
	NP_KEY:'student_nextPage'
}



// WEBPACK FOOTER //
// ./src/const.js